<template>
  <div>
    <q-form autofocus greedy @submit="onSubmit" @reset="onReset">
      <q-card flat :style="!$q.screen.lt.md && isDialog?'width: 500px; max-width: 80vw;':''">
        <q-card-section class="no-padding" v-if="isDialog">
          <q-banner class="bg-blue text-white" inline-actions>
            <span>برقرای تماس داخلی</span>
          </q-banner>
        </q-card-section>
        <q-card-section>
          <q-select v-model="selectedAgent"
                    :options="userListOptions"
                    filled
                    @filter="filterFn"
                    use-input
                    option-value="Users_ID"
                    option-label="UserName"
                    label="انتخاب کارشناس"
                    :rules="[requireRole]"
          />
        </q-card-section>

        <q-separator/>

        <q-card-actions align="right">
          <q-btn color="indigo" icon="phone_in_talk" type="submit">برقراری تماس</q-btn>
          <q-btn flat color="red" type="reset" icon="cancel" v-close-popup>انصراف</q-btn>
        </q-card-actions>
      </q-card>
    </q-form>
  </div>
</template>
<script>
import {mapActions} from "vuex";

export default {
  name: "InternalCall",
  props: {
    isDialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedAgent: undefined,
      userList: [],
      userListOptions: []
    }
  },
  methods: {
    ...mapActions({
      sendMessage: 'sendMessage',
      getUsers: 'Users/getUsers'
    }),
    filterFn(val, update) {
      update(() => {
        this.userListOptions = this.userList.filter(v => v.UserName.indexOf(val) > -1)
      })
    },
    onSubmit() {
      if (this.selectedAgent.AvayaExt){
        this.sendMessage(`${this.$store.state.internalUserMobile}&${this.$store.state.userMobile}&${this.selectedAgent.AvayaExt}`).then((res) => {
          if (res.msg === 'success') {
            this.$q.notify({
              type: 'positive',
              position: 'top',
              color: 'positive',
              message: 'تا لحظاتی دیگر تماس شما از طریق مرکز تماس نوران برقرار خواهد شد، لطفا اندکی تامل فرمایید'
            });
          } else {
            this.$q.notify({
              type: 'negative',
              position: 'top',
              color: 'negative',
              message: 'ارتباط با مرکر تماس قطع است'
            });
            this.onReset();
          }
        }).catch(() => {
          this.$q.notify({
            type: 'negative',
            position: 'top',
            color: 'negative',
            message: 'ارتباط با مرکر تماس قطع است'
          });
          this.onReset()
        });
      }else{
        this.$q.notify({
          type: 'negative',
          position: 'top',
          color: 'negative',
          message: 'شماره داخلی تعریف نشده است'
        });
      }
    },
    onReset() {
      this.selectedAgent = undefined
    },
    requireRole(val) {
      if (val === null || val === undefined || val === '') {
        return 'انتخاب الزامی است'
      }
    },
  },
  created() {
    this.getUsers().then((res) => {
      this.userList = res.filter(item=> item.AvayaExt)
      this.userListOptions = this.userList
    })
  }
}
</script>

<style scoped>

</style>